import { Stack } from '@mui/material';
import { ActiveListItem } from 'components/datagrid/listItems/ActiveListItem';
import { Text } from 'components/text/Text';
import { Button } from '@nps.today/component-library';
import { SingleSelect } from 'components/util/select/SingleSelect';
import { useEffect, useState } from 'react';
import useCustomDispatch from 'redux/dispatch';
import {
  getAiFeedbackConfiguration,
  getAvailableCampaigns,
  UpdateAiFeedbackConfiguration
} from 'redux/slices/aiFeedbackConfiguration';
import { RootState, useSelector } from 'redux/store';
import { useTranslator } from 'translation/useTranslator';

export const AdminAiFeedbackConfiguration = () => {
  const translator = useTranslator();
  const { configuration, availableCampaigns, isLoading } = useSelector(
    (state: RootState) => state.aiFeedbackConfiguration
  );
  const [selectedCampaignId, setSelectedCampaignId] = useState<number>(
    configuration?.aiSupportFeedbackCampaign?.id ?? 0
  );
  const customDispatch = useCustomDispatch();

  useEffect(() => {
    customDispatch({
      action: getAvailableCampaigns,
      disableSuccessMessage: true
    });
    customDispatch({
      action: getAiFeedbackConfiguration,
      disableSuccessMessage: true,
      onSuccess: ({ result }) => {
        if (result?.data) {
          const campaignId = result.data?.aiSupportFeedbackCampaign?.id;
          setSelectedCampaignId(campaignId);
        }
      }
    });
  }, [customDispatch]);

  const handleSave = () => {
    customDispatch({
      action: UpdateAiFeedbackConfiguration,
      actionParameters: {
        campaignId: selectedCampaignId
      }
    });
  };

  return (
    <Stack gap={2}>
      <Stack flexDirection="row" justifyContent="space-between">
        <Text variant="h6">{translator.aiFeedbackConfiguration()}</Text>
        <Button
          variant="contained"
          dataTestId="save-ai-feedback-configuration"
          disabled={
            isLoading || selectedCampaignId === configuration?.aiSupportFeedbackCampaign?.id
          }
          onClick={handleSave}
        >
          {translator.save()}
        </Button>
      </Stack>
      <SingleSelect
        items={availableCampaigns.map((c) => ({ value: c.id, displayValue: c.name }))}
        dataTestId="ai-feedback-campaign"
        label={translator.campaigns()}
        value={selectedCampaignId}
        onChange={(i) => setSelectedCampaignId(i.value)}
        renderItem={(i) => {
          return (
            <Stack flexDirection={'row'} justifyContent={'space-between'} width={'100%'}>
              <Text>
                {i.displayValue} - {i.value}
              </Text>
              <ActiveListItem
                activeTooltip={translator.active()}
                inactiveTooltip={translator.inactive()}
                active={availableCampaigns.find((c) => c.id === i.value)?.active ?? false}
              />
            </Stack>
          );
        }}
        helperText={translator.selectAiFeedbackCampaignHelperText()}
      />
    </Stack>
  );
};
